import Image from 'next/image';
import styled from 'styled-components';
import { Button } from '@/components';

export const BorderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing[24]} ${theme.spacing[16]}`};
  border: 1px solid ${({ theme }) => theme.colors.pressedBlack};
  border-radius: 4px;
  word-break: break-word;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const PeopleImage = styled(Image).attrs({
  width: 64,
  height: 64,
  unoptimized: true,
})(({ theme }) => ({
  objectFit: 'cover',
  objectPosition: 'center center',
  borderRadius: '50%',
  marginRight: theme.spacing[16],

  [`${theme.mediaBreakpointUp.md}`]: {
    marginBottom: theme.spacing[16],
    marginRight: 0,
  },
}));

export const CustomButton = styled(Button)`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing[16]};
`;
